import styled, { css, keyframes } from 'styled-components';
import { ANIMATION_DURATION } from '../../DesignSystem/design-system';
const chevronFlipAnimation = keyframes `
  from { transform: rotate(0deg); }
  to { transform: rotate(180deg); }
`;
const chevronFlipBackAnimation = keyframes `
  from { transform: rotate(180deg); }
  to { transform: rotate(0deg); }
`;
const getChevronAnimation = (isAnimatingChevron, rotationDuration) => {
    switch (isAnimatingChevron) {
        case 'forward':
            return css `
        animation: ${chevronFlipAnimation}
          ${rotationDuration || ANIMATION_DURATION} linear forwards;
      `;
        case 'backward':
            return css `
        animation: ${chevronFlipBackAnimation}
          ${rotationDuration || ANIMATION_DURATION} linear forwards;
      `;
        default:
            return css `
        animation: none;
      `;
    }
};
export const ImpRotatingChevron = styled.div `
  cursor: pointer;
  ${(props) => getChevronAnimation(props.chevronAnimation, props.rotationDuration)}
`;
//# sourceMappingURL=ImpRotatingChevron.js.map